import Gemora from '../../assets/workimages/Gemora.jpg';
import JobFever from '../../assets/workimages/JobFever.jpg';
import DungeonAdventures from '../../assets/workimages/DungeonAdventures.jpg';
import KampShop from '../../assets/workimages/KampShop.jpg';
import MonsterAdventures from '../../assets/workimages/MonsterAdventures.png';
import AskMate from '../../assets/workimages/AskMate.png';
import Battleship from '../../assets/workimages/Battleship.png';
import PolishDraughts from '../../assets/workimages/PolishDraughts.png';
import StarWars from '../../assets/workimages/StarWars.jpg';
import CodecoolSeries from '../../assets/workimages/CodecoolSeries.jpg';

export const workSectionTitle = 'Projects';
export const workSectionSubtitle = 'Most recent works';
export const projectsData = [
    {
        id: 1,
        image: Gemora,
        title: 'Gemora',
        repository: 'https://github.com/stelmaszczykadrian/Gemora-frontend',
    },
    {
        id: 2,
        image: JobFever,
        title: 'Job Fever',
        repository: 'https://github.com/stelmaszczykadrian/jobFever-frontend',
    },
    {
        id: 3,
        image: DungeonAdventures,
        title: 'Dungeon Adventures',
        repository: 'https://github.com/stelmaszczykadrian/Dungeon-Adventures',
    },
    {
        id: 4,
        image: KampShop,
        title: 'Kamp Shop',
        repository: 'https://github.com/stelmaszczykadrian/KAMP-shop-2.0',
    },
    {
        id: 5,
        image: MonsterAdventures,
        title: 'Monster Adventures',
        repository: 'https://github.com/stelmaszczykadrian/Monster-Adventures',
    },
    {
        id: 6,
        image: AskMate,
        title: 'Ask Mate',
        repository: 'https://github.com/stelmaszczykadrian/Ask-Mate',
    },
    {
        id: 7,
        image: Battleship,
        title: 'Battleship',
        repository: 'https://github.com/stelmaszczykadrian/Battleship-OOP',
    },
    {
        id: 8,
        image: PolishDraughts,
        title: 'Polish Draughts',
        repository: 'https://github.com/stelmaszczykadrian/Polish-draughts',
    },
    {
        id: 9,
        image: StarWars,
        title: 'Star Wars',
        repository: 'https://github.com/stelmaszczykadrian/Api-Wars',
    },
    {
        id: 10,
        image: CodecoolSeries,
        title: 'Codecool Series',
        repository: 'https://github.com/stelmaszczykadrian/Codecool-series',
    },

]
